import { Route } from '@angular/router';

import { PrivateLayout } from '@layouts/private/private.layout';
import { authGuard } from '@guards/auth.guard';

export const routes: Route[] = [
  {
    path: 'a',
    component: PrivateLayout,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

      {
        path: 'dashboard',
        loadComponent: () =>
          import('@components/pages/private/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent,
          ),
        title: 'Dashboard',
      },
      {
        path: 'transactions',
        loadComponent: () =>
          import('@components/pages/private/transactions/transactions.component').then(
            (m) => m.TransactionsComponent,
          ),
        title: 'Transactions',
      },
      {
        path: 'statements',
        loadComponent: () =>
          import('@components/pages/private/statements/statements.component').then(
            (m) => m.StatementsComponent,
          ),
        title: 'Statements',
      },

      {
        path: 'clients',
        loadComponent: () =>
          import('@components/pages/private/clients/clients.component').then(
            (m) => m.ClientsComponent,
          ),
        title: 'Clients',
      },
      {
        path: 'client-types',
        loadComponent: () =>
          import('@components/pages/private/client-types/client-types.component').then(
            (m) => m.ClientTypesComponent,
          ),
        title: 'Client Types',
      },
      {
        path: 'payment-methods',
        loadComponent: () =>
          import('@components/pages/private/payment-methods/payment-methods.component').then(
            (m) => m.PaymentMethodsComponent,
          ),
        title: 'Payment Methods',
      },
      {
        path: 'users',
        loadComponent: () =>
          import('@components/pages/private/users/users.component').then((m) => m.UsersComponent),
        title: 'Users',
      },

      {
        path: 'partners',
        loadComponent: () =>
          import('@components/pages/private/partners/partners.component').then(
            (m) => m.PartnersComponent,
          ),
        title: 'Partners',
      },
      {
        path: 'credentials',
        loadComponent: () =>
          import('@components/pages/private/credentials/credentials.component').then(
            (m) => m.CredentialsComponent,
          ),
        title: 'API Credentials',
      },
      {
        path: 'accounts',
        loadComponent: () =>
          import('@components/pages/private/accounts/accounts.component').then(
            (m) => m.AccountsComponent,
          ),
        title: 'Ledger Accounts',
      },

      {
        path: 'charges',
        loadComponent: () =>
          import('@components/pages/private/charges/charges.component').then(
            (m) => m.ChargesComponent,
          ),
        title: 'Charges',
      },
      {
        path: 'channels',
        loadComponent: () =>
          import('@components/pages/private/channels/channels.component').then(
            (m) => m.ChannelsComponent,
          ),
        title: 'Channels',
      },
      {
        path: 'transaction-types',
        loadComponent: () =>
          import('@components/pages/private/transaction-types/transaction-types.component').then(
            (m) => m.TransactionTypesComponent,
          ),
        title: 'Transaction Types',
      },

      {
        path: 'currencies',
        loadComponent: () =>
          import('@components/pages/private/currencies/currencies.component').then(
            (m) => m.CurrenciesComponent,
          ),
        title: 'Currencies',
      },
      {
        path: 'banks',
        loadComponent: () =>
          import('@components/pages/private/banks/banks.component').then((m) => m.BanksComponent),
        title: 'Banks',
      },

      {
        path: 'portal-users',
        loadComponent: () =>
          import('@components/pages/private/portal-users/portal-users.component').then(
            (m) => m.PortalUsersComponent,
          ),
        title: 'Portal Users',
      },
      {
        path: 'configuration',
        loadComponent: () =>
          import('@components/pages/private/configuration/configuration.component').then(
            (m) => m.ConfigurationComponent,
          ),
        title: 'Configuration',
      },

      {
        path: 'profile',
        loadComponent: () =>
          import('@components/pages/private/profile/profile.component').then(
            (m) => m.ProfileComponent,
          ),
        title: 'Profile',
      },
      {
        path: 'forbidden',
        loadComponent: () =>
          import('@components/pages/private/forbidden/forbidden.component').then(
            (m) => m.ForbiddenComponent,
          ),
        title: 'No access',
      },
    ],
  },
];
